import Splide from '@splidejs/splide';

const EL = '.js-cards';

document.querySelectorAll(EL).forEach((el) => {
  const slider = new Splide(el, {
    pagination: false,
    fixedWidth: '309px',
    gap: 40,
    arrows: true,
    breakpoints: {
      1365: {
        fixedWidth: '270px',
        gap: 20,
      },
      1024: {
      },
      767: {
        fixedWidth: '200px',
        gap: 10,
      },
    },
  });

  slider.mount();
});
